import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PassengerType } from 'src/app/core/enums/enums';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionComponent {
  @Input() expand = false;
  @Input() isSelected = false;
  @Input() theme: string;
  @Input() size: string;
  @Input() maxHeight: string;
  @Input() showArrow = true;
  @Input() arrowRight = false;
  @Input() arrowBottom = false;
  @Input() fullColumn = false;
  @Input() is11Title = false;
  @Input() bordered = false;
  @Input() isVcentered = true;
  @Input() borderedBottom = false;
  @Input() contentOverflow = false;
  @Input() visibleOverflow = false;
  @Input() hasExtraRow = false;
  @Input() needDynamicClass = false;
  @Input() passengerType = '';
  @Input() passengersListByFareBasis = [];
  @Output() isToggled = new EventEmitter<boolean>();

  inputAdultValue = 'inputadult';
  inputChildValue = 'inputchild';
  inputInfantValue = 'inputinfant';

  adultAccordionClass = 'adult-ml-accordion-container';
  childAccordionClass = 'child-ml-accordion-container';
  infantAccordionClass = 'infant-ml-accordion-container';

  toggleDetail() {
    this.expand = !this.expand;
    this.isToggled.emit(this.expand);
  }

  onChangeClasses(): string {
    let classDefintion = '';
    if (this.needDynamicClass) {
      switch (this.passengerType) {
        case this.inputAdultValue:
          this.passengersListByFareBasis.includes(PassengerType.Adult) &&
            (classDefintion = this.adultAccordionClass);
          break;
        case this.inputChildValue:
          this.passengersListByFareBasis.includes(PassengerType.Child) &&
            (classDefintion = this.childAccordionClass);
          break;
        case this.inputInfantValue:
          this.passengersListByFareBasis.includes(PassengerType.Infant) &&
            (classDefintion = this.infantAccordionClass);
          break;
        default:
          classDefintion = '';
          break;
      }
      return classDefintion;
    } else {
      return '';
    }
  }
}
